// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "CallToAction-module--backgroundContainmentImage--578a2";
export var backgroundImage = "CallToAction-module--backgroundImage--f3696";
export var content = "CallToAction-module--content--fcd53";
export var ctaBtn = "CallToAction-module--ctaBtn--5e851";
export var ctaWrapper = "CallToAction-module--ctaWrapper--0e643";
export var logo = "CallToAction-module--logo--e780f";
export var wrapper = "CallToAction-module--wrapper--65624";